/**
 * Core Textarea Component
 */
import React from 'react';
import { TextField } from '@mui/material';

export interface TextareaProps {
  label?: string;
  id?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
  required?: boolean;
  name?: string;
}

export const Textarea = React.forwardRef<HTMLDivElement, TextareaProps>(
  ({ rows = 4, fullWidth = true, className = '', ...props }, ref) => (
    <TextField ref={ref} multiline rows={rows} variant="outlined" size="small" fullWidth={fullWidth} className={className} {...props} />
  )
);
Textarea.displayName = 'Textarea';
export default Textarea;
